import { addNavMenuItem, addActionBarItem } from "@vendure/admin-ui/core";
export default [
  addNavMenuItem(
    {
      id: "ads",
      label: "Ads",
      routerLink: ["extensions", "ads"],
    },
    "sales",
  ),

  // addActionBarItem({
  //   id: "assign-ad",
  //   locationId: "customer-detail",
  //   label: "Anuncio",
  //   icon: "📣",
  //   routerLink: (route) => {
  //     const id = route.snapshot.params.id;
  //     return ["/extensions/ads/create"];
  //   },
  // }),
];
